"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialProductState = void 0;
exports.initialProductState = {
    asin: '',
    tenant: ''
};
